<template>
    <div class="widget-list" style="background-color: #c4e88b">
        <span class="widget-list__title"> Кредиторы-участники программ господдержки </span>
        <custom-select :options="getValues" :reset-btn="false" class="select" :tabindex="1" @input="setSelected" />
        <template v-if="options.length > 0">
            <div class="table-row">
                <div class="table-row table-row__header">
                    <div class="table-row__title">
                        Наименование организации
                    </div>
                    <div class="table-row__data">
                        ИНН
                    </div>
                </div>
                <div v-for="(option, i) in getShortList" :key="i" class="table-row g-card">
                    <div class="table-row__title">
                        <span>{{ option.name }}</span>
                    </div>
                    <div class="table-row__data">
                        {{ option.inn }}
                    </div>
                </div>
            </div>
            <div class="widget-list__btn">
                <ui-button @click.prevent="showModal()">
                    Показать весь список
                </ui-button>
            </div>
        </template>
        <ui-modal ref="modal" :need-close-button="true" class="widget-list-modal">
            <p class="ui-modal-container__header">
                Кредиторы-участники программ господдержки
            </p>
            <div class="ui-modal-container__body">
                <div class="widget-list" style="padding:0">
                    <custom-select
                        :options="getValues" :reset-btn="false" class="select-modal" :tabindex="activeIndex"
                        @input="setLongList"
                    />
                    <div class="widget-list-wrapper">
                        <template v-if="longList.length > 0">
                            <div class="table-row table-row__header">
                                <div class="table-row__title">
                                    Наименование организации
                                </div>
                                <div class="table-row__data">
                                    ИНН
                                </div>
                            </div>
                            <div v-for="(option, i) in longList" :key="i">
                                <div class="table-row g-card">
                                    <div class="table-row__title">
                                        <span>{{ option.name }}</span>
                                    </div>
                                    <div class="table-row__data">
                                        {{ option.inn }}
                                    </div>
                                </div>
                            </div>
                        </template>
                    </div>
                </div>
            </div>
            <p class="ui-modal-container__footer" />
        </ui-modal>
    </div>
</template>

<script>
import CustomSelect from './ui/CustomSelect';
import UiButton from './ui/UiButton';
import UiModal from './modals/UiModal';

export default {
    name: 'WidgetListView',
    components: { CustomSelect, UiButton, UiModal },
    // eslint-disable-next-line vue/require-prop-types
    props: ['privilege', 'family', 'it', 'dv'],
    data() {
        return {
            mortgage: [{ 'Льготная Ипотека': 'privilege' }, { 'Семейная ипотека': 'family' }, { 'Ипотека для IT': 'it' }, { 'Дальневосточная ипотека': 'dv' }],
            options: [],
            longList: [],
            shortlistSize: 8,
            activeIndex: null
        };
    },
    computed: {
        getValues() {
            const arr = [];
            this.mortgage.forEach((el) => {
                const key = Object.keys(el);
                const value = Object.values(el);
                arr.push({ text: key[0], value: value[0] });
            });
            return arr;
        },
        getShortList() {
            return this.options.slice(0, this.shortlistSize);
        }
    },
    mounted() {
        this.getMortgageList();
    },
    methods: {
        getMortgageList() {
            const arr = [];
            this.mortgage.forEach((el) => {
                const key = Object.keys(el);
                const value = Object.values(el);
                arr.push({ text: key[0], value: value[0] });
            });
        },
        setSelected(option) {
            let entries;
            let arr;
            if (typeof (option) === 'object') {
                this.options = JSON.parse(this.$props[option.value]);
                entries = Object.entries(option);
                arr = entries.map((el) => el[1]);
                this.activeIndex = this.mortgage.findIndex((el) => el[arr[0]]);
            }
        },
        setLongList(option) {
            if (typeof (option) === 'object') {
                this.longList = JSON.parse(this.$props[option.value]);
            }
        },
        showModal() {
            this.$refs.modal.openModal();
        }
    }
};
</script>
